type Props = {};

const About = (props: Props) => {
  return (
    <div className='about-content'>
      <p>
        Welcome to Cloudmark - a new bookmark manager extension that makes
        saving, organizing and sharing bookmarks easy.
      </p>
      <p>
        My vision is to reimagine bookmarking as a cloud-powered collaborative
        experience that fits seamlessly into your browsing habits. We want to
        help you save valuable links across devices, find them easily later, and
        share relevant bookmarks with team and friends.
      </p>
      <p>
        Cloudmark is currently in early access and available as a{" "}
        <a
          href='https://chrome.google.com/webstore/detail/cloudmark-collaborative-b/ljcjjbhegcjomooleldkpiobchfghlkn'
          target='_blank'
          rel='noreferrer'
          className='link'
        >
          Chrome extension
        </a>
        . We are working on adding support for other browsers and platforms. If
        you have any questions or feedback, please feel free to reach out to{" "}
        <a href='mailto:cg.collaborate@gmail.com' className='link'>
          cg.collaborate@gmail.com
        </a>{" "}
        with any questions or feedback. We thank you for supporting this early
        release of Cloudmark!
      </p>
      <p>
        Feedback form:{" "}
        <a
          href='https://bit.ly/cloudmark-feedback'
          target='_blank'
          rel='noreferrer'
          className='link'
        >
          https://bit.ly/cloudmark-feedback
        </a>
      </p>
    </div>
  );
};

export default About;
